import { createSelector } from 'reselect';

import type { HrisImportEmployeeChangeLog } from '../typescript-types/hris-import-employee-change-log';

import { StateDictionary } from '../reducers/utils/state-manager';

import { HrisImportLog } from '../typescript-types/hris-import-log';

export type HrisImportLogState = {
  hrisImportLogsById: { [hrisImportLogId: number]: HrisImportLog };
  hrisImportLogsStateByMergeIntegrationId: StateDictionary;
  hrisImportEmployeeChangeLogsById: { [hrisImportLogId: number]: HrisImportEmployeeChangeLog[] };
  hrisImportEmployeeChangeLogsStateByHrisImportLogId: StateDictionary;
};
type State = { hrisImportLogs: HrisImportLogState };

const hrisImportLogsByIdSelector = (state: State) => state.hrisImportLogs.hrisImportLogsById;
const hrisImportLogsSelector = createSelector([hrisImportLogsByIdSelector], (hrisImportLogsById) =>
  Object.values(hrisImportLogsById),
);

export const hrisImportLogForMergeIntegrationIdSelector = createSelector(
  [hrisImportLogsSelector, (_state: State, mergeIntegrationId: number) => mergeIntegrationId],
  (hrisImportLogs, mergeIntegrationId) =>
    hrisImportLogs.filter((s) => s.mergeIntegrationId === mergeIntegrationId),
);

const hrisImportLogsStateByMergeIntegrationIdSelector = (state: State) =>
  state.hrisImportLogs.hrisImportLogsStateByMergeIntegrationId;
export const hrisImportLogsStateForMergeIntegrationIdSelector = createSelector(
  [
    hrisImportLogsStateByMergeIntegrationIdSelector,
    (_state: State, mergeIntegrationId: number) => mergeIntegrationId,
  ],
  (hrisImportLogsStateByMergeIntegrationId, mergeIntegrationId) =>
    hrisImportLogsStateByMergeIntegrationId[mergeIntegrationId],
);

const hrisImportEmployeeChangeLogsByIdSelector = (state: State) =>
  state.hrisImportLogs.hrisImportEmployeeChangeLogsById;

export const hrisImportEmployeeChangeLogsForHrisImportLogIdSelector = createSelector(
  [
    hrisImportEmployeeChangeLogsByIdSelector,
    (_state: State, hrisImportLogId: number) => hrisImportLogId,
  ],
  (hrisImportEmployeeChangeLogsById, hrisImportLogId) =>
    hrisImportEmployeeChangeLogsById[hrisImportLogId],
);

export const hrisImportEmployeeChangeLogsForHrisImportLogIdAndOrgIdSelector = createSelector(
  [
    hrisImportEmployeeChangeLogsByIdSelector,
    (_state: State, hrisImportLogId: number) => hrisImportLogId,
    (_state: State, _hrisImportLogId: number, orgId?: number) => orgId,
  ],
  (hrisImportEmployeeChangeLogsById, hrisImportLogId, orgId) =>
    hrisImportEmployeeChangeLogsById[hrisImportLogId]
      ? hrisImportEmployeeChangeLogsById[hrisImportLogId].filter((log) =>
          orgId ? log.orgId === orgId : log,
        )
      : [],
);

const hrisImportEmployeeChangeLogsStateByHrisImportLogIdSelector = (state: State) =>
  state.hrisImportLogs.hrisImportEmployeeChangeLogsStateByHrisImportLogId;
export const hrisImportEmployeeChangeLogsStateForHrisImportLogIdSelector = createSelector(
  [
    hrisImportEmployeeChangeLogsStateByHrisImportLogIdSelector,
    (_state: State, mergeIntegrationId: number) => mergeIntegrationId,
  ],
  (hrisImportEmployeeChangeLogsStateByHrisImportLogId, mergeIntegrationId) =>
    hrisImportEmployeeChangeLogsStateByHrisImportLogId[mergeIntegrationId],
);
